const root = 'membership';

export const SignUpRoute = {
  ROOT: root,
  INTRO: `${root}/intro`,
  DETAILS: `${root}/details`,
  BILLING: `${root}/billing`,
  SUCCESS: `${root}/success`,
}
